import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail, FiPhone, FiTwitter, FiLinkedin, FiGithub } = FiIcons;

const Footer = () => {
  const footerLinks = {
    Product: [
      { label: 'How it works', href: '#how-it-works' },
      { label: 'Features', href: '#features' },
      { label: 'For Recruiters', href: '#recruiter-workflow' },
      
    ],
   
    Legal: [
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Terms of Service', href: '/terms' },
      //{ label: 'Cookie Policy', href: '#cookies' },
      //{ label: 'GDPR', href: '#gdpr' }
    ]
  };

  const socialLinks = [
    { icon: FiTwitter, href: '#twitter', label: 'Twitter' },
    { icon: FiLinkedin, href: '#linkedin', label: 'LinkedIn' },
    { icon: FiGithub, href: '#github', label: 'GitHub' }
  ];

  return (
    <footer className="bg-slate-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <motion.div
            className="lg:col-span-2"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="flex items-center space-x-2 mb-6">
              <div className="w-8 h-8 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">IS</span>
              </div>
              <span className="font-display font-bold text-xl">Instashortlist</span>
            </div>
            
            <p className="text-slate-300 mb-6 leading-relaxed">
              Proudly built for recruiters who want efficient, fair hiring. 
              Transform your recruitment process with AI-powered intelligence.
            </p>

            <div className="space-y-3">
              <div className="flex items-center space-x-3 text-slate-300">
                <SafeIcon icon={FiMail} className="w-5 h-5" />
                <a href="mailto:support@instashortlist.com" className="hover:text-white transition-colors">
                  support@instashortlist.com
                </a>
              </div>
              <div className="flex items-center space-x-3 text-slate-300">
                <SafeIcon icon={FiPhone} className="w-5 h-5" />
                <a href="tel:+15551234567" className="hover:text-white transition-colors"> +91 96182 22498 </a>
              </div>
            </div>
          </motion.div>

          {/* Footer Links */}
          {Object.entries(footerLinks).map(([category, links], index) => (
            <motion.div
              key={category}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <h3 className="font-semibold text-lg mb-4">{category}</h3>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-slate-300 hover:text-white transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        {/* Bottom Section */}
        <motion.div
          className="border-t border-slate-700 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
        >
         <div className="text-slate-400 text-sm text-center w-full">
  © 2025 Instashortlist. All rights reserved.
</div>


          {/* Social Links 
          <div className="flex space-x-6">
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.href}
                className="text-slate-400 hover:text-white transition-colors"
                aria-label={social.label}
              >
                <SafeIcon icon={social.icon} className="w-6 h-6" />
              </a>
            ))}
          </div>*/}
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;